




























































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import HhAuditService from "@/services/HhAuditService";

@Component
export default class HhAuditDetail extends Vue {
  @Prop({ required: true }) readonly sessionId!: number;

  session: any = null;
  signing = false;
  signDialog = false;
  signRole: "kaunit" | "komite_ppi" | "" = "";
  password = "";

  momenLabelsMap: Record<string, string> = {
    seb_ps: "Seb-ps · Sebelum kontak pasien",
    seb_asept: "Seb-asept · Sebelum tindakan aseptik",
    set_drh_cairan: "Set-drh.c.tbh · Setelah terpapar darah/cairan",
    set_ps: "Set-ps · Setelah kontak pasien",
    set_lkg_ps: "Set.lkg-ps · Setelah kontak lingkungan"
  };

  tindakanLabelsMap: Record<string, string> = {
    hr: "HR",
    hw: "HW",
    tidak_hh: "Tidak HH",
    sarung_tgn: "Sarung Tgn"
  };

  hambatanLabelsMap: Record<string, string> = {
    abhr_tidak_tersedia: "Tidak tersedia ABHR di titik perawatan",
    wastafel_tidak_berfungsi: "Wastafel tidak berfungsi / tidak ada sabun",
    kulit_iritasi: "Kulit tangan iritasi / tidak ada moisturiser",
    beban_kerja_tinggi: "Beban kerja tinggi / terburu-buru",
    lupa_indikasi: "Lupa / tidak aware indikasi momen",
    sarung_pengganti: "Sarung tangan dianggap pengganti HH"
  };

  // Katalog blok (label & urutan) diambil dari server
  blokOptions: string[] = [];
  blokLabels: Record<string, string> = {};

  get rate(): string {
    return Number(this.session?.skor_total ?? this.session?.compliance_rate ?? 0).toFixed(2);
  }

  get detailTitle(): string {
    const j = this.session?.jenis_audit;
    if (j === "fasilitas") return "Audit Fasilitas Hand Hygiene";
    if (j === "kepatuhan") return "Audit Kepatuhan Hand Hygiene";
    return "Audit Hand Hygiene";
  }

  get isFasilitasAudit(): boolean {
    return this.session?.jenis_audit === "fasilitas";
  }

  get hasFasilitas(): boolean {
    return this.isFasilitasAudit && this.itemsOf("fasilitas").length > 0;
  }

  get hasKepatuhan(): boolean {
    return ["saat_hh", "hand_wash", "hand_rub"].some(b => this.itemsOf(b).length > 0);
  }

  /**
   * Hanya blok yang benar-benar punya item pada sesi ini. Blok fasilitas (A)
   * kini form terpisah, jadi disembunyikan kecuali sesi ber-jenis "fasilitas"
   * (sesi lama "gabungan" ditampilkan sebagai audit kepatuhan).
   */
  get visibleBloks(): string[] {
    return this.blokOptions.filter(b => {
      if (b === "fasilitas" && !this.isFasilitasAudit) return false;
      return this.itemsOf(b).length > 0;
    });
  }

  get waktuAudit(): string {
    return (this.session?.waktu_audit || "").slice(0, 5);
  }

  itemsOf(blok: string): any[] {
    return (this.session?.items || []).filter((i: any) => i.blok === blok);
  }

  blokTally(blok: string): { ya: number; tidak: number } {
    const items = this.itemsOf(blok);
    return {
      ya: items.filter((i: any) => i.hasil === "ya").length,
      tidak: items.filter((i: any) => i.hasil === "tidak").length
    };
  }

  get petugasList(): any[] {
    return (this.session?.petugas || []).slice().sort((a: any, b: any) => a.urutan - b.urutan);
  }

  get canSignKaunit(): boolean {
    return !!this.session && !!this.session.signed_auditor_at && !this.session.signed_kaunit_at;
  }

  get canSignKomitePpi(): boolean {
    return !!this.session && !!this.session.signed_kaunit_at && !this.session.signed_komite_ppi_at;
  }

  get signRoleLabel(): string {
    if (this.signRole === "kaunit") return "Kepala Ruangan / Ka. Unit";
    if (this.signRole === "komite_ppi") return "Komite PPI / Manajer Mutu";
    return "";
  }

  async mounted() {
    const cat = await HhAuditService.catalog();
    this.blokOptions = cat.data.data.blok_options;
    this.blokLabels = cat.data.data.blok_labels;
    await this.load();
  }

  async load() {
    const res = await HhAuditService.find(this.sessionId);
    this.session = res.data.data;
  }

  findKes(p: any, ke: number): any {
    const list = p.kesempatan || [];
    return list.find((k: any) => k.kesempatan_ke === ke) || { momen: null, tindakan: null };
  }

  momenLabel(m: string | null): string {
    return m ? this.momenLabelsMap[m] || m : "—";
  }

  tindakanLabel(t: string | null): string {
    return t ? this.tindakanLabelsMap[t] || t : "—";
  }

  hambatanLabel(h: string): string {
    return this.hambatanLabelsMap[h] || h;
  }

  tindakanColor(v: string): string {
    if (v === "hr" || v === "hw") return "success";
    if (v === "tidak_hh") return "error";
    if (v === "sarung_tgn") return "warning";
    return "grey";
  }

  signedName(role: "kaunit" | "komite_ppi"): string {
    const rel = role === "kaunit" ? this.session.signed_kaunit : this.session.signed_komite_ppi;
    return rel?.identitas?.nama || rel?.name || "—";
  }

  bulanName(m: number): string {
    const names = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    return names[m] || String(m);
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID") + " " + d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
  }

  openSign(role: "kaunit" | "komite_ppi") {
    this.signRole = role;
    this.password = "";
    this.signDialog = true;
  }

  async doSign() {
    if (!this.password || !this.signRole) return;
    this.signing = true;
    try {
      if (this.signRole === "kaunit") {
        await HhAuditService.approveKaunit(this.sessionId, { password: this.password });
      } else {
        await HhAuditService.approveKomitePpi(this.sessionId, { password: this.password });
      }
      this.signDialog = false;
      await this.load();
      this.$emit("updated");
    } finally {
      this.signing = false;
    }
  }

  printPdf() {
    HhAuditService.printPdf(this.sessionId);
  }
}
